import { hasFrontendVersionOverride } from './frontendVersionOverrides';

/**
 * Setup frontend version persistence with lazy-loaded navigation interceptor
 * Only initializes if a frontend version parameter is present at load time
 */
export function initializeFrontendVersionPersistence(): void {
  if (hasFrontendVersionOverride()) {
    // Lazy-load the navigation interceptor to avoid blocking initial app load
    import(/* webpackChunkName: "FrontendVersionNavigationInterceptor" */ './navigationInterceptor')
      .then(({ setupNavigationInterceptor }): void => {
        setupNavigationInterceptor();
      })
      .catch(() => {
        // do nothing, since this doesn't impact customer user of the app
      });
  }
}
